<script>
	import { statusBadgeStyle } from "src/utils/statusBadge";

	export let row = {};
	export let key = "";
	export let options = {};

	$: value = row[key] || "";
	$: variant =
		options?.[value] ??
		Object.entries(options || {}).find(
			([label]) => label.toLowerCase() === value.trim().toLowerCase()
		)?.[1];
</script>

<span class="status-badge" style={statusBadgeStyle(variant)}>
	{value.toUpperCase()}
</span>

<style>
	.status-badge {
		display: inline-block;
		border-radius: 4px;
		padding: 4px 8px;
		font-size: 12px;
		font-weight: bold;
		white-space: nowrap;
	}
</style>
